import { render, staticRenderFns } from "./ordersucess.vue?vue&type=template&id=393dcdba"
import script from "./ordersucess.vue?vue&type=script&lang=js"
export * from "./ordersucess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports